export function doubleDigit(val) {
  return String(val).padStart(2, '0')
}
